import type { WorkflowGraphEvent, WorkflowGraphEventListener } from './types';

/**
 * Framework-agnostic typed event emitter. WorkflowGraph delegates its
 * subscriber set to this helper to keep the class body clean.
 */
export class TypedEventBus {
  private listeners = new Set<WorkflowGraphEventListener>();

  on(listener: WorkflowGraphEventListener): () => void {
    this.listeners.add(listener);
    return () => {
      this.listeners.delete(listener);
    };
  }

  emit(event: WorkflowGraphEvent): void {
    this.listeners.forEach((l) => l(event));
  }

  clear(): void {
    this.listeners.clear();
  }

  get size(): number {
    return this.listeners.size;
  }
}
